import { Card } from "@/components/ui/card";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { useTranslation } from "@/contexts/LanguageContext";

interface RevenueChartProps {
  data?: Array<{ month: string; revenue: number; target: number }>;
}

export function RevenueChart({ data }: RevenueChartProps) {
  const { t } = useTranslation();
  const chartData = data && data.length > 0 ? data : [
    { month: "Jan", revenue: 65000, target: 70000 },
    { month: "Fev", revenue: 72000, target: 75000 },
    { month: "Mar", revenue: 68000, target: 73000 },
    { month: "Abr", revenue: 81000, target: 80000 },
    { month: "Mai", revenue: 78000, target: 82000 },
    { month: "Jun", revenue: 85000, target: 85000 },
  ];
  return (
    <Card className="p-6">
      <div className="mb-4">
        <h3 className="text-lg font-semibold">{t('revenueEvolutionTitle')}</h3>
        <p className="text-sm text-muted-foreground">{t('revenueEvolutionSubtitle')}</p>
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
          <XAxis 
            dataKey="month" 
            stroke="hsl(var(--muted-foreground))"
            fontSize={12}
          />
          <YAxis 
            stroke="hsl(var(--muted-foreground))"
            fontSize={12}
            tickFormatter={(value) => `R$ ${(value / 1000).toFixed(0)}k`}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: "hsl(var(--card))",
              border: "1px solid hsl(var(--border))",
              borderRadius: "var(--radius)",
            }}
            formatter={(value: number) => `R$ ${value.toLocaleString("pt-BR")}`}
          />
          <Legend />
          <Line
            type="monotone"
            dataKey="revenue"
            stroke="hsl(var(--primary))"
            strokeWidth={3}
            name={t('revenue')}
            dot={{ fill: "hsl(var(--primary))", r: 4 }}
            activeDot={{ r: 6 }}
          />
          <Line
            type="monotone"
            dataKey="target"
            stroke="hsl(var(--muted))"
            strokeWidth={2}
            strokeDasharray="5 5"
            name={t('target')}
            dot={{ fill: "hsl(var(--muted))", r: 3 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </Card>
  );
}
